import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type HTMLAttributes, computed } from 'vue'
import type { StepperDescriptionProps } from 'radix-vue'
import { StepperDescription, useForwardProps } from 'radix-vue'

import { cn } from '@/lib/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'StepperDescription',
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(__props: any) {

const props = __props

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardProps(delegatedProps)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StepperDescription), _mergeProps(_unref(forwarded), {
    class: _unref(cn)('text-xs text-muted-foreground', props.class)
  }), {
    default: _withCtx((slotProps) => [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(slotProps)))
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})